import React, { useEffect, useState } from 'react';

import {
  isMobile,
  isSupportedBrowser,
  isDesktop,
  isTablet,
  isLandscape,
  hasWebGl,
} from 'utils/platform';
import { desktopMinHeight, breakpointDesktop } from 'utils/styles/vars';
import { useWindowSize } from 'hooks/useWindowSize';

import Unsupported from './Unsupported';
import JavaScriptDisabled from './JavaScriptDisabled';
import RotateDevice from './RotateDevice';
import WindowTooSmall from './WindowTooSmall';
import NoWebGl from './NoWebGl';

interface NonFunctionalsProps {
  children: React.ReactNode | React.ReactNode[];
}

const NonFunctionals = ({ children }: NonFunctionalsProps) => {
  const [isMounted, setMounted] = useState<boolean>(false);
  const [isRendered, setRendered] = useState<boolean>(false);
  const [showUnsupported, setShowUnsupported] = useState<boolean>(false);
  const [
    isSubStandardBrowserAccepted,
    setSubstandardBrowserAccepted,
  ] = useState(false);
  const [isTooSmall, setTooSmall] = useState<boolean>(false);
  const [shouldRotate, setRotate] = useState<boolean>(false);
  const windowSize = useWindowSize();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      setRendered(true);

      const { isSupported, needsUpgrade } = isSupportedBrowser();
      setShowUnsupported(!isSupported || needsUpgrade);
    }
  }, [isMounted]);

  useEffect(() => {
    setTooSmall(
      isDesktop() &&
        (windowSize.width < breakpointDesktop ||
          windowSize.height < desktopMinHeight)
    );

    setRotate((isMobile() && isLandscape()) || (isTablet() && isLandscape()));
  }, [windowSize]);

  let errorComponent = null;
  if (!isRendered) {
    errorComponent = <JavaScriptDisabled />;
  } else if (showUnsupported && !isSubStandardBrowserAccepted) {
    errorComponent = <Unsupported setAccept={setSubstandardBrowserAccepted} />;
  } else if (!hasWebGl()) {
    errorComponent = <NoWebGl />;
  }

  return (
    <>
      {children}
      {errorComponent}
      {isRendered && isTooSmall && <WindowTooSmall />}
      {isRendered && shouldRotate && <RotateDevice />}
    </>
  );
};

export default NonFunctionals;
